<template>
  <b-modal
    id="mensagens-ausencia-modal"
    ref="mensagensAusenciaModal"
    title="Mensagens de Ausência">
    <div class="form-group row">
      <div class="col-md-12">
        <label for="horasAusente">Horas Ausente:</label>
        <b-form-select
          id="horasAusente"
          v-model="form.horasAusente.value"
          :options="form.horasAusente.options"
          :required="form.horasAusente.required"
          :state="form.horasAusente.state"
        />
      </div>

      <div class="col-md-12 mt-3">
        <label for="mensagem">Mensagem:</label>
        <b-form-textarea
          id="mensagem"
          v-model="form.mensagem.value"
          :rows="3"
          :required="form.mensagem.required"
          :state="form.mensagem.state"
        />
      </div>

      <div class="col-md-12 mt-3">
        <b-form-checkbox
          id="finalizaConversa"
          class="ml-3"
          switch
          v-model="form.finalizaConversa.value"
        >Finaliza Conversa</b-form-checkbox>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 text-right">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-b-tooltip.hover
          @click="onSave"
          :title="'Gravar'"
        >
          <i class="fa fa-check"></i
          ><span class="d-md-down-none"> Gravar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import Form from './addForm'
import Data from '@/shared/models/configurations/mensagemausentemodel.js'
import MensagemAusenteRepository from '@/shared/http/repositories/configurations/mensagemausente.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'MensagensAusenciaModal',
  data () {
    return {
      form: Form,
      data: Data
    }
  },
  methods: {
    async onEdit (id) {
      loading.push()
      try {
        this.onClear()
        const response = await MensagemAusenteRepository.GetById(id)
        const data = response.data
        if (data.id !== null) {
          Tools.SetValueInForm(this.form, this.data, data)
          this.$refs.mensagensAusenciaModal.show()
        } else {
          toast.error('Não foi possível carregar a mensagem de ausência')
        }
      } catch (error) {
        toast.error('Erro ao carregar mensagem de ausência')
      } finally {
        loading.pop()
      }
    },
    onAdd () {
      this.onClear()
      this.$refs.mensagensAusenciaModal.show()
    },
    onClear () {
      this.form.horasAusente.value = null
      this.form.mensagem.value = null
      this.form.finalizaConversa.value = null

      this.data.id = null
      this.data.horasAusente = null
      this.data.mensagem = null
      this.data.finalizaConversa = null
    },
    onSave () {
      if (this.data.id) {
        this.onUpdate()
      } else {
        this.onCreate()
      }
    },
    async onCreate () {
      loading.push()
      try {
        if (!Tools.ValidateForms(this.form, this.data, self, toast)) {
          loading.pop()
          return
        }
        const response = await MensagemAusenteRepository.Create(this.data)
        const { id } = response.data
        if (id !== null) {
          toast.success('Mensagem de ausência criada com sucesso!')
          this.$emit('Reload')
          this.$refs.mensagensAusenciaModal.hide()
          this.onClear()
        } else {
          toast.error('Erro ao criar mensagem de ausência')
        }
      } catch (error) {
        toast.error('Erro ao criar mensagem de ausência: ' + error.message)
      } finally {
        loading.pop()
      }
    },
    async onUpdate () {
      loading.push()
      try {
        if (!Tools.ValidateForms(this.form, this.data, self, toast)) {
          loading.pop()
          return
        }
        const response = await MensagemAusenteRepository.Update(this.data)
        const { id } = response.data
        if (id !== null) {
          toast.success('Mensagem de ausência atualizada com sucesso!')
          this.$refs.mensagensAusenciaModal.hide()
          this.onClear()
          this.$emit('Reload')
        } else {
          toast.error('Erro ao atualizar mensagem de ausência')
        }
      } catch (error) {
        toast.error('Erro ao atualizar mensagem de ausência: ' + error.message)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensAusencia/components/addModal.vue